import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount } from '../hooks/use-account';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { storageToken } = useAccount();
  const session = storageToken();

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkSession = useCallback(() => {
    if (!session) {
      setIsLoggedIn(false);
      return navigate('/login');
    }
    setIsLoggedIn(true);
    return undefined;
  }, [session, navigate]);

  useEffect(() => {
    checkSession();
  }, [checkSession, isLoggedIn]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isLoggedIn ? children : null}</>;
};

export default ProtectedRoute;
